<template>
  <article class="culture-wrapper culture" id="culture1">
    <div class="container">
      <p class="text0">CARROT 기업문화</p>
      <VueSlickCarousel v-bind="settings">
        <div class="slide">
          <div class="text-wrapper">
            <p>01</p>
            <p>아웃팅</p>
            <p>
              안 가본 길을 가야, 못해본 짓을 하지! <br />
              캐럿글로벌의 Outing Program은 <br />
              CARROTian들의 가치를 키워가는 글로벌 배낭여행 Project입니다.
              <br />
              매년 3박 4일 ~ 9박 10일까지 <br />
              'Exploring & Experience'라는 Outing spirit을 <br />
              실천하며 다녀오는 글로벌 배낭여행 Outing! <br />
              당근영어의 행복 프로그램입니다.
            </p>
            <p @click="goPage('/Culture#outing')">more</p>
          </div>
          <img
            src="@/assets/img/newGlobal/introduce/main/culture/img00.png"
            alt="img"
          />
        </div>
        <div class="slide">
          <div class="text-wrapper">
            <p>02</p>
            <p>멘토링</p>
            <p>
              2004년 5월부터 시작되어 100회가 넘은 독서토론회로 <br />자체적인
              독서와 자기개발을 통하여 <br />더 좋은 아이디어와 서비스를 <br />
              재창출 할 수 있도록 운영하고 있습니다.
            </p>
            <p @click="goPage('/Culture#mentoring')">more</p>
          </div>
          <img
            src="@/assets/img/newGlobal/introduce/main/culture/img01.png"
            alt="img"
          />
        </div>
        <div class="slide">
          <div class="text-wrapper">
            <p>03</p>
            <p>리더십포럼</p>
            <p>
              CARROT 리더십 포럼은, 알찬 프로그램을 통해
              <br />CARROT 리더들의 의식을 확장하고 리더십을 고양하는
              자리입니다. <br />리더십포럼은 다양한 액티비티뿐만 아니라
              <br />리더들이 고민하는 바를 함께 공유하고 <br />그에 대한
              해결방안을 모색함으로써, <br />서로에게 많은 의지와 도움이 되고
              있습니다.
            </p>
            <p @click="goPage('/Culture#leadershipForum')">more</p>
          </div>
          <img
            src="@/assets/img/newGlobal/introduce/main/culture/img01.png"
            alt="img"
          />
        </div>
      </VueSlickCarousel>
    </div>
  </article>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 1350,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  methods: {
    goPage(path) {
      location.href = path;
    },
  },
};
</script>
<style lang="scss" scoped>
.culture::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

#culture1::before {
  background: #adeff6;
}

#culture2::before {
  background: #b6dfff;
}

.culture-wrapper {
  position: relative;
  background-color: #f7f7f7;
  padding: 40px 0;

  @media screen and (min-width: 1350px) {
    padding: 80px 0;
  }

  .text0 {
    font-size: 33px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 24px;

    @media screen and (min-width: 1350px) {
      font-size: 50px;
      margin-bottom: 40px;
    }
  }

  .slick-slider::v-deep {
    .slick-slide {
      .slide {
        display: flex !important;
        justify-content: space-between;
        flex-direction: column-reverse;
        gap: 50px;

        @media screen and (min-width: 1350px) {
          flex-direction: row;
        }

        .text-wrapper {
          p {
            &:nth-of-type(1) {
              font-size: 22px;

              @media screen and (min-width: 1350px) {
                font-size: 30px;
              }
            }

            &:nth-of-type(2) {
              font-size: 20px;
              margin-bottom: 24px;

              @media screen and (min-width: 1350px) {
                font-size: 40px;
                margin-bottom: 40px;
              }
            }

            &:nth-of-type(3) {
              margin-bottom: 50px;

              @media screen and (min-width: 1350px) {
                font-size: 22px;
              }
            }

            &:nth-of-type(4) {
              display: inline-block;
              font-size: 14px;
              cursor: pointer;
            }
          }
        }
      }
    }

    .slick-prev {
      left: -50px;
    }

    .slick-next {
      right: -50px;
    }

    .slick-prev,
    .slick-next {
      width: 40px;
      height: 40px;

      &::before {
        font-size: 40px;
        color: #000000;
      }
    }

    .slick-dots {
      position: relative;
      text-align: center;
      bottom: -30px;

      li {
        width: 24px;
        height: 24px;

        button {
          width: 24px;
          height: 24px;

          &::before {
            font-size: 24px;
          }
        }
      }
    }
  }
}
</style>
